import type { ColumnDef } from "@tanstack/react-table";

/**
 * Columnas para la tabla de imágenes
 */
export const businessTableColumns: ColumnDef<{
  modality: string;
  amount: number;
  color: string;
  percentage: string | number;
}>[] = [
  {
    accessorKey: "color",
    header: "Color",
    cell: ({ row }) => {
      const color = row.getValue("color") as string;
      return <div className="w-4 h-4 rounded-full" style={{ backgroundColor: color }} />;
    },
  },
  {
    accessorKey: "modality",
    header: "Modalidad",
  },
  {
    accessorKey: "amount",
    header: "Cantidad",
  },
  {
    accessorKey: "percentage",
    header: "Porcentaje",
    cell: ({ row }) => `${row.getValue("percentage")}%`,
  },
];
